<template>
  <b-modal
    id="medpadala-error-modal"
    title="MEDPadala"
    centered
    header-class="align-items-center"
    title-class="text-center flex-grow-1"
    hide-footer
    body-class="py-4"
  >
    <b-row>
      <b-col cols="9" class="mx-auto mb-2">
        <div class="text-center mb-3">
          <img
            src="@/assets/images/medpadala_error.svg"
            alt="MEDPadala Error"
            class="img-fluid"
          />
        </div>
        <p class="text-center">{{ medPadalaErrors }}</p>
        <b-button
          v-if="
            medPadalaErrors && typeof medPadalaErrors !== 'object'
              ? medPadalaErrors.toLowerCase().includes('invalid pin')
              : medPadalaErrors
          "
          variant="primary"
          class="text-uppercase py-2 border-0"
          block
          pill
          :style="{
            backgroundColor:
              webDesign && webDesign.design
                ? `${webDesign.design.main_color} !important`
                : null,
            color:
              webDesign && webDesign.design
                ? `${webDesign.design.button_text_color} !important`
                : null
          }"
          @click="proceed"
        >
          Ok
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: "MEDPadalaError",
  computed: {
    ...mapGetters({
      medPadalaErrors: "medpadala/medPadalaErrors",
      medPadalaData: "medpadala/medPadalaData"
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign,
      cart: state => state.cart
    }),
    ...mapFields("medpadala", ["code", "pin"])
  },
  methods: {
    proceed() {
      this.$root.$emit("bv::hide::modal", "medpadala-error-modal");
      this.$nextTick(() => {
        if (!this.medPadalaData.code) {
          this.code = this.cart.estore_wallets.find(
            wallet => wallet.type === "med-padala"
          ).wallet_code;
        }
        this.pin = null;
        this.$root.$emit("bv::show::modal", "medpadala-modal");
      });
    }
  }
};
</script>
